<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
    v-if="item.id"
  >
    <o-form-group>
      <h2 class="task-title">{{ task_types[item.task_type] }}</h2>
    </o-form-group>

    <o-form-group v-if="canApprove">
      <b-button
        :variant="approve_button_variant"
        @click="approve()"
        :disabled="is_rejected"
        >Approve</b-button
      >
    </o-form-group>
    <o-form-group v-if="canApprove">
      <b-button
        :variant="reject_button_variant"
        @click="reject()"
        :disabled="is_approved"
        >Reject</b-button
      >
    </o-form-group>

    <o-widget-wrapper
      v-if="item.when"
      :schema="schema"
      name="when"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.when"
        name="when"
        v-bind="schema.fields.when"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        readonly
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="item.who"
      :schema="schema"
      name="who"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.who"
        :items="optionEmployeeItems"
        text-field="full_name"
        value-field="id"
        sort-field="full_name"
        :form-state="formState"
        :loading="optionEmployeeWorking"
        name="who"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.who"
        readonly
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="note"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
      v-if="note_visible"
    >
      <o-text-area
        v-model="item.note"
        :form-state="formState"
        :label="note_label"
        name="note"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.note"
        :readonly="!canApprove"
      ></o-text-area>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<style>
.task-title {
  margin-top: 2%;
}
</style>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import UserMixin from "../../mixins/UserMixin";
import { mapGetters } from "vuex";

import { default as EmployeeForm } from "../../employee/components/ItemForm";
import * as LEAVE_TASK_STATUS from "../../leave_task_status.js";
import * as LEAVE_TASK_TYPES from "../../leave_task_types.js";
import {
  LeaveTaskTypeText,
  MANAGER_APPROVAL,
  PAYROLL_APPROVAL,
  CANCEL_APPROVAL,
} from "../../leave_task_types.js";
import {
  LTA_APPROVED,
  LTA_NOP,
  LTA_REJECTED,
} from "@/app/leave_task_actions.js";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("LeaveRequestTask"),
    CreateCodeTableFetchMixin(["Employee"]),
    UserMixin,
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,

    EmployeeForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.LeaveRequestTask, {}),
    task_types: LeaveTaskTypeText,
  }),
  methods: {
    clear_status() {
      this.formState.dirty = true;
      this.item.status = LEAVE_TASK_STATUS.PENDING;
      this.item.when = null;
      this.item.who = null;
      this.item.note = "";
      this.item.action = LTA_NOP;

      this.$emit("pending", this.item);
    },
    setCurrentUserAsWho() {
      var profileId = this.currentUser && this.currentUser.profile
        ? this.currentUser.profile.id
        : null;

      if (profileId) {
        this.item.who = profileId;
      }
    },
    approve() {
      this.formState.dirty = true;
      if (this.item.status === LEAVE_TASK_STATUS.APPROVED) {
        this.clear_status();
      } else {
        this.item.status = LEAVE_TASK_STATUS.APPROVED;
        this.item.when = new Date();
        this.item.note = "";
        this.item.action = LTA_APPROVED; //approved
        this.setCurrentUserAsWho();
        this.$emit("approved", this.item);
      }
    },
    reject() {
      this.formState.dirty = true;
      if (this.item.status === LEAVE_TASK_STATUS.REJECTED) {
        this.clear_status();
      } else {
        this.item.status = LEAVE_TASK_STATUS.REJECTED;
        this.item.when = new Date();
        this.item.note = "";
        this.item.action = LTA_REJECTED; // reject
        this.setCurrentUserAsWho();
        this.$emit("rejected", this.item);
      }
    },
  },
  computed: {
    canApprove() {
      return this.isManager || this.isPayroll || this.isAdministrator;
    },
    is_rejected() {
      return this.item.status === LEAVE_TASK_STATUS.REJECTED;
    },
    is_approved() {
      return this.item.status === LEAVE_TASK_STATUS.APPROVED;
    },

    note_visible() {
      if (
        this.item.task_type === LEAVE_TASK_TYPES.MANAGER_APPROVAL &&
        this.is_rejected
      ) {
        return true;
      }
      if (
        this.item.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL &&
        (this.is_rejected || this.is_approved)
      ) {
        return true;
      }
      if (
        this.item.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL &&
        this.is_rejected
      ) {
        return true;
      }

      return false; // Not visible by default.
    },
    note_label() {
      if (this.is_approved) {
        return "Approval Note";
      }
      if (this.is_rejected) {
        return "Rejection Note";
      }

      return "Note";
    },
    reject_button_variant() {
      if (this.is_rejected) {
        return "danger";
      }
      return "outline-secondary";
    },
    approve_button_variant() {
      if (this.is_approved) {
        return "success";
      }
      return "outline-secondary";
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    ...mapGetters("AuthModule", ["currentUser"]),
  },
  watch: {},
  created() {},
};
</script>
